(function () {
  'use strict';
  function initialize(root) {
    if (root.dataset.woCheckerReady) return;
    var product = document.getElementById('product-' + root.dataset.productId);
    var form = product && product.querySelector('form[data-wo-vehicle-form]');
    var core = window.WOProductFitmentCore, cart = window.WOVehicleCart;
    if (!form || !core || !cart || !cart.getVehicle || !cart.setVehicle) return;
    var messages, data, normalized;
    try {
      messages = JSON.parse(root.querySelector('[data-wo-checker-i18n]').textContent);
      data = JSON.parse(form.querySelector('[data-wo-product-json]').textContent);
      normalized = core.normalizeProduct(data);
    } catch (_) { return; }
    root.dataset.woCheckerReady = 'true';
    form.dataset.woFitmentManaged = 'true'; cart.attach(form);
    function t(key) { return messages[key] || key; }
    function find(name) { return root.querySelector('[data-wo-checker-' + name + ']'); }
    var ui = { picker:find('picker'), vehicle:find('vehicle'), label:find('vehicle-label'), change:find('change'),
      result:find('result'), alternatives:find('alternatives'), alternative:find('alternative'), use:find('use'),
      note:find('note'), help:find('help'), retry:find('retry') };
    var picker = ui.picker.querySelector('[data-wo-vehicle-picker]');
    var endpoint = picker.dataset.endpoint;
    var state = { detail:null, reference:null, controller:null, sequence:0, last:null };
    function syncBusy() { root.inert = form.getAttribute('aria-busy') === 'true'; }
    new MutationObserver(syncBusy).observe(form, {attributes:true, attributeFilter:['aria-busy']});
    syncBusy();
    var keys = ['year', 'make', 'model', 'modification'];
    function element(tag, text, cls) {
      var node = document.createElement(tag); node.textContent = text;
      if (cls) node.className = cls;
      return node;
    }
    function vehicleLabel(detail) { return keys.map(function (key) { return detail.labels[key]; }).join(' · '); }
    function label(variant) {
      return variant.options.map(function (value, index) {
        return /^(et|offset)(\s|$)/i.test(data.options[index]) ? 'ET ' + String(value).replace(/^\s*ET\s*/i, '') : value;
      }).join(' · ');
    }
    function selections() {
      if (typeof form.woFitmentSelections === 'function') return form.woFitmentSelections();
      var master = form.querySelector('[name="id"]');
      return master && master.value ? [{id:master.value, axle:null}] : [];
    }
    function contact() {
      var ask = product.querySelector('[data-wo-inquiry]');
      var url = new URL(ask ? ask.href : ui.help.getAttribute('href'), location.origin);
      url.searchParams.set('wo_from', 'product');
      url.searchParams.set('wo_product', product.querySelector('h1').textContent.trim());
      url.searchParams.set('wo_product_url', location.pathname + location.search);
      var current = selections().map(function (selection) { return data.variants.find(function (variant) { return String(variant.id) === String(selection.id); }); }).filter(Boolean);
      url.searchParams.set('wo_options', current.map(label).join(' / '));
      if (state.detail) url.searchParams.set('wo_vehicle', vehicleLabel(state.detail));
      else url.searchParams.delete('wo_vehicle');
      ui.help.href = url.pathname + url.search;
      ui.help.textContent = t(state.detail ? 'help' : 'contact');
    }
    function status(kind, heading, description) {
      ui.result.hidden = false; ui.result.dataset.state = kind;
      ui.result.replaceChildren(element('strong', heading));
      if (kind === 'suggested') {
        var mark = element('span', '', 'wo-product-fitment__checkmark');
        mark.setAttribute('aria-hidden', 'true');
        ui.result.replaceChildren(mark, element('strong', heading));
      }
      if (description) ui.result.append(element('p', description));
    }
    function isMatch(result) { return result.status === 'suggested'; }
    function render() {
      if (!root.isConnected || !state.reference || !state.detail) return;
      var selected = selections();
      if (!selected.length) { status('unknown', t('no_active')); ui.alternatives.hidden = true; contact(); return; }
      var checks = selected.map(function (choice) {
        var result = core.check(state.reference, normalized, choice.id);
        if (isMatch(result) && choice.axle && result.selected.axle !== 'both' && result.selected.axle !== choice.axle) result.status = 'not_suggested';
        return { choice:choice, result:result, variant:data.variants.find(function (variant) { return String(variant.id) === String(choice.id); }) };
      });
      var kind = checks.every(function (check) { return isMatch(check.result); }) ? 'suggested' :
        checks.some(function (check) { return check.result.status === 'unknown'; }) ? 'unknown' : 'review';
      status(kind, t(kind));
      checks.forEach(function (check) {
        if (!check.variant) return;
        var axle = check.choice.axle || (check.result.selected && check.result.selected.axle);
        var prefix = axle && axle !== 'both' ? t(axle) + ': ' : '';
        ui.result.append(element('p', prefix + label(check.variant), 'wo-product-fitment__configuration'));
        if (isMatch(check.result) && axle && axle !== 'both') ui.result.append(element('p', t('axle_note')));
        if (!check.variant.available) ui.result.append(element('p', t('out_of_stock')));
      });
      var ids = new Set(selected.map(function (choice) { return String(choice.id); }));
      var alternativeId = ui.alternative.value;
      var alternatives = checks[0].result.matches.filter(function (candidate) {
        return candidate.variant.available && (!ids.has(candidate.variant.id) || candidate.variant.id === alternativeId);
      });
      ui.alternative.replaceChildren();
      alternatives.forEach(function (candidate) {
        var variant = data.variants.find(function (item) { return String(item.id) === candidate.variant.id; });
        if (!variant) return;
        var option = element('option', label(variant) + ' — ' + t(candidate.axle));
        option.value = candidate.variant.id; ui.alternative.append(option);
      });
      if (Array.from(ui.alternative.options).some(function (option) { return option.value === alternativeId; })) ui.alternative.value = alternativeId;
      ui.alternatives.hidden = !ui.alternative.options.length;
      ui.note.textContent = t('note');
      ui.note.hidden = false; contact();
    }
    function retire() {
      state.sequence++;
      if (state.controller) state.controller.abort();
      state.controller = null; state.reference = null; state.detail = null; state.last = null;
      form.dispatchEvent(new CustomEvent('wo:fitment-vehicle-changing'));
      cart.setVehicle(null);
      ui.vehicle.hidden = true; ui.picker.hidden = false; ui.result.hidden = true;
      ui.note.hidden = true; ui.alternatives.hidden = true; ui.retry.hidden = true;
      ui.alternative.replaceChildren();
      ui.result.setAttribute('aria-busy', 'false'); contact();
    }
    async function check(detail, preserve) {
      if (form.getAttribute('aria-busy') === 'true') return;
      if (!preserve && !cart.setVehicle(detail)) { status('error', t('unavailable')); return; }
      state.detail = cart.getVehicle();
      if (!state.detail) return;
      state.last = state.detail;
      if (state.controller) state.controller.abort();
      var sequence = ++state.sequence, controller = new AbortController(), timedOut = false;
      state.controller = controller; state.reference = null;
      ui.label.textContent = vehicleLabel(state.detail); ui.vehicle.hidden = false; ui.picker.hidden = true;
      ui.alternatives.hidden = true; ui.note.hidden = true; ui.retry.hidden = true;
      ui.alternative.replaceChildren();
      status('checking', t('checking')); ui.result.setAttribute('aria-busy', 'true'); contact();
      var timer = setTimeout(function () { timedOut = true; controller.abort(); }, 30000);
      try {
        var response = await fetch(endpoint, {method:'POST', mode:'cors', credentials:'omit', cache:'no-store',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify(Object.assign({step:'fitment'}, state.detail.vehicle)), signal:controller.signal});
        if (!response.ok) throw new Error('unavailable');
        var payload = await response.json();
        if (payload.error || !Array.isArray(payload.records) || payload.records.length !== 1 || !payload.records[0]) throw new Error('unavailable');
        if (sequence !== state.sequence || controller.signal.aborted || !root.isConnected) return;
        state.reference = payload.records[0]; render();
      } catch (_) {
        if (sequence !== state.sequence || !root.isConnected) return;
        status('error', t(timedOut ? 'timeout' : 'unavailable')); ui.retry.hidden = false;
      } finally {
        clearTimeout(timer);
        if (sequence === state.sequence) { state.controller = null; ui.result.setAttribute('aria-busy', 'false'); }
      }
    }
    root.addEventListener('wo:vehicle-submit', function (event) {
      event.preventDefault(); event.stopPropagation(); check(event.detail, false);
    });
    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-wo-vehicle-picker]')) retire();
    }, true);
    root.addEventListener('wo:vehicle-invalid', retire);
    document.addEventListener('wo:vehicle-reset', function () { if (root.isConnected) retire(); });
    ui.change.addEventListener('click', function () {
      ui.picker.hidden = !ui.picker.hidden;
      ui.change.setAttribute('aria-expanded', String(!ui.picker.hidden));
      if (!ui.picker.hidden) { var year = picker.querySelector('[name="year"]'); if (year) year.focus(); }
    });
    ui.retry.addEventListener('click', function () { if (state.last) check(state.last, true); });
    ui.use.addEventListener('click', function () {
      if (!ui.alternative.value || form.getAttribute('aria-busy') === 'true') return;
      form.dispatchEvent(new CustomEvent('wo:fitment-select-variant', {detail:{variantId:ui.alternative.value}}));
      render();
    });
    form.addEventListener('change', function () { queueMicrotask(render); });
    window.addEventListener('variantChange', render);
    var saved = cart.getVehicle();
    try {
      var arrival = new URL(location.href);
      if (arrival.searchParams.has('wo_vehicle')) {
        keys.concat('trim').forEach(function (key) { arrival.searchParams.delete(key); });
        window.history.replaceState(window.history.state, '', arrival.pathname + arrival.search + arrival.hash);
        if (!saved) sessionStorage.removeItem('wo-fitment:selected-vehicle:v1');
      }
    } catch (_) {}
    if (saved) {
      try {
        var pickerSaved = {};
        keys.forEach(function (key) { pickerSaved[key] = {value:saved.vehicle[key], label:saved.labels[key]}; });
        sessionStorage.setItem('wo-fitment:selected-vehicle:v1', JSON.stringify(pickerSaved));
      } catch (_) {}
      check(saved, true);
    }
  }
  function boot() { document.querySelectorAll('[data-wo-product-fitment]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
